import React from "react";
import { Helmet } from "react-helmet";

export const UIPageTitle = (props: { pageTitle }) => {
	console.debug("UIPageTitle pageTitle:", props.pageTitle);
	return (
		<Helmet>
			<title>{props.pageTitle}</title>
		</Helmet>
	);
};
